export default "__VITE_ASSET__C72pQDu7__"